import type { LinkInBioEventSummary } from '@repo/lib';
import { formatDateTime } from '../format-date';

const DEFAULT_LOCALE = 'en-US';

function toSupportedLocale(locale: string | null | undefined) {
  if (!locale) return DEFAULT_LOCALE;
  try {
    return Intl.DateTimeFormat.supportedLocalesOf(locale)[0] ?? DEFAULT_LOCALE;
  } catch {
    return DEFAULT_LOCALE;
  }
}

function toValidTimeZone(timeZone: string | null | undefined) {
  if (!timeZone) return 'UTC';
  try {
    new Intl.DateTimeFormat(DEFAULT_LOCALE, { timeZone });
    return timeZone;
  } catch {
    return 'UTC';
  }
}

export function formatLinkInBioEventDate(
  event: Pick<LinkInBioEventSummary, 'startDate' | 'timezone'>,
  locale?: string | null,
): string | null {
  if (!event.startDate) return null;

  const label = formatDateTime(event.startDate, {
    timeZone: toValidTimeZone(event.timezone),
    timeZoneName: 'short',
    locale: toSupportedLocale(locale),
  });

  return typeof label === 'string' && label ? label : null;
}
